define('views/lib/Podio.Views.UnsupportedBrowser',['require','translate','jquery','lib/backbone/Backbone.PodioView','lib/Podio.UI.Modal','jst!unsupported_browser/_modal'],function(require) {

  var t = require('translate');
  var $ = require('jquery');
  var PodioView = require('lib/backbone/Backbone.PodioView');
  var modal = require('lib/Podio.UI.Modal');

  var jstModal = require('jst!unsupported_browser/_modal');

  return PodioView.extend({

    podioEvents : {
      'click .ok-button' : 'onOkButtonClicked'
    },

    initialize: function(options) {
      this._super();

      this.browsers = options.browsers;
    },

    render: function() {
      $(window).scrollTop(0);

      var html = this.getTemplate(jstModal, {
        browsers: this.browsers
      });

      modal.show(html, {
        title : t('Unsupported Browser #unsupportedbrowser'),
        className: 'unsupported-browser-warning-modal',
        disableCloseOptions: true
      });

      this.elm = $('.unsupported-browser-warning-modal');
      this.setElement(this.elm.get(0));
      this.podioDelegateEvents();
    },

    onOkButtonClicked: function(elmTarget, e) {
      this.trigger('viewUnsupportedBrowser:finishedTrigger');
    }

  });

});

